import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import Heading from '@bibliocommons/heading';
import FeatureTogglz from 'app/components/bibs/shared/FeatureTogglz';
import { TOGGLZ_FEATURES } from '@bibliocommons/constants-feature-togglz';
import { DetailsContainer } from './Details';
import { AboutTheAuthorContainer } from './AboutTheAuthor';
import { SameSeriesContainer } from './SameSeries';
import { ContainsContainer } from './Contains';
import { SubjectAndGenreContainer } from './SubjectAndGenre';
import { ContributorsContainer } from './Contributors';
import Distinctions from './Distinctions';
import { MediaSummaryContainer } from './MediaSummary';

import './About.scss';

export default class About extends React.PureComponent {
  render() {
    const { trackFieldItemClick } = this.props;

    return (
      <section className="cp-bib-about container">
        <div className="row">
          <div className="col-lg-3">
            <Heading tagName="h2" size="moderate" variant>
              <FormattedMessage id="about_section" />
            </Heading>
          </div>
          <div className="col-lg-7">
            <MediaSummaryContainer />
            <AboutTheAuthorContainer />
            <FeatureTogglz>
              {features => (features.get(TOGGLZ_FEATURES.NERF_BIB_PAGE_DEVELOPMENT) ? <Distinctions /> : null)}
            </FeatureTogglz>
            <SameSeriesContainer />
            <ContributorsContainer trackFieldItemClick={trackFieldItemClick} />
            <ContainsContainer trackFieldItemClick={trackFieldItemClick} />
            <SubjectAndGenreContainer trackFieldItemClick={trackFieldItemClick} />
            <DetailsContainer trackFieldItemClick={trackFieldItemClick} showDetailsMetadata />
          </div>
        </div>
      </section>
    );
  }
}

About.propTypes = {
  trackFieldItemClick: PropTypes.func.isRequired
};
